import {Box, Typography} from '@mui/material';
import './InvestigateHeader.scss';
import {t} from 'i18next';
import ArrButton from '../../../common/arr-button/ArrButton';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';
import {Trans} from 'react-i18next';
import ArrTooltipWrapper from '../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {ReactComponent as InfoIcon} from '../../../../assets/images/info-icon.svg';

const InvestigateHeader = () => {
  const navigate = useNavigate();
  const userRights = useSelector(
    (state: RootState) => state.actionmenu.userRights
  );

  return (
    <Box
      component="header"
      className="investigate-header-container"
      data-testid="investigate-header"
      aria-labelledby="ai-investigate-heading"
    >
      <Typography
        component="h3"
        className="typo-text headline3_size investigate-heading-text"
        data-testid="ai-investigate-heading-text"
        id="ai-investigate-heading"
      >
        {t('ai.investigate.aiInvestigate')}
        <ArrTooltipWrapper
          title={t('ai.investigate.aiInvestigate')}
          trigger={
            <InfoIcon
              className="info-icon ai-investigate-info-icon"
              aria-hidden="true"
              focusable="false"
            />
          }
        >
          <Trans
            i18nKey={t('ai.investigate.aiInvestigateHeaderTooltipContent')}
            components={{
              br: <br data-testid="ai-investigate-heading-grid-br" />,
              strong: (
                <strong data-testid="ai-investigate-heading-grid-strong" />
              ),
              p: <p data-testid="ai-investigate-heading-grid-p" />,
            }}
          />
        </ArrTooltipWrapper>
      </Typography>
     
      {userRights && userRights?.canManageIndices && (
        <ArrButton
          aria-label={t('ai.investigate.manageIndices')}
          variant="secondary"
          size="medium"
          dataTestId="ai-manage-indices-btn"
          onClick={() => navigate('manage-indices')}
        >
          {t('ai.investigate.manageIndices')}
        </ArrButton>
      )}
    </Box>
  );
};

export default InvestigateHeader;
